import en from "./en"
import fa from "./fa"
import ar from "./ar"

export default {
    en,
    fa,
    ar
}